<template>
  <div id="app">
    <!-- <div style="position:relative;"> -->
    <transition :name="pageTransitionName" @before-enter="handleBeforeEnter" @after-enter="handleAfterEnter">

      <keep-alive v-if="$route.meta.keepAlive">
        <router-view class="app-wrapper" />
      </keep-alive>

      <router-view v-if="!$route.meta.keepAlive" class="app-wrapper" />

    </transition>

    <!-- 隐私声明提示弹窗 -->
    <protocol-notice-box v-if="isShowNotice"></protocol-notice-box>
    <!-- 隐私协议查看弹窗 -->
    <protocol-popup v-if="isShowContent"></protocol-popup>

  </div>
  <!-- </div> -->
</template>
<script>
// import fetch from './plugin/axios/fetch.js'
// import { checkBrowser } from './plugin/channel/setUserChannel'
import protocolPopup from '@/components/protocolPopup/index.vue'
import protocolNoticeBox from '@/components/protocolPopup/notice.vue'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      show: true,
      appId: '', // 必填，公众号的唯一标识
      timestamp: '', // 必填，生成签名的时间戳
      nonceStr: '', // 必填，生成签名的随机串
      signature: ''
    }
  },
  components: {
    protocolPopup,
    protocolNoticeBox
  },
  computed: {
    pageTransitionName () {
      if (this.$store) {
        return this.$store.state.emsCli.appShell.pageTransitionName
      }
      return ''
    },
    ...mapState('protocol', {
      isShowNotice: state => state.isShowNotice,
      isShowContent: state => state.isShowContent
    })
  },

  created () {
    let endTime = new Date('2020/04/05 00:00:00').getTime()
    if (new Date().getTime() < endTime) {
      this.moifyStyle()
    }
    if (this.isShowNotice) {
      this.$refs.protocolMsgBoxRef && (this.$refs.protocolMsgBoxRef.showMsgBox())
    }

    // if (checkBrowser() === 'WECHAT') {
    //   this.getThirdParameters(() => {
    //     // 微信配置 调用
    //     wx.config({
    //       debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //       appId: this.appId, // 必填，公众号的唯一标识
    //       timestamp: this.timestamp, // 必填，生成签名的时间戳
    //       nonceStr: this.nonceStr, // 必填，生成签名的随机串
    //       signature: this.signature, // 必填，签名
    //       jsApiList: ['scanQRCode', 'startRecord', 'stopRecord', 'playVoice', 'stopVoice', 'uploadVoice', 'translateVoice', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'checkJsApi', 'hideOptionMenu'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    //     })
    //   })
    // }
  },
  methods: {
    moifyStyle () {
      let style = document.createElement('style')
      style.type = 'text/css'
      style.innerHTML = `html{
     filter: grayscale(100%);
     filter: gray;
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
}`
      document.getElementsByTagName('head').item(0).appendChild(style)
    },
    // getThirdParameters (func) {
    //   let urlstr = location.href.split('#')
    //   this.$fetch.post('/getThirdParameters', {
    //     url: urlstr[0]
    //   }, 'application/x-www-form-urlencoded;charset=UTF-8').then(res => {
    //     if (res.data && res.data.code === '000000') {
    //       this.appId = res.data.info.jsapi.appId
    //       this.timestamp = res.data.info.jsapi.timestamp
    //       this.nonceStr = res.data.info.jsapi.nonceStr
    //       this.signature = res.data.info.jsapi.signature
    //     }
    //   })
    // },
    setPageSwitching (val) {
      return this.$store
        ? this.$store.dispatch('emsCli/appShell/setPageSwitching', val)
        : () => { console.log('please open vuex first') }
    },
    handleBeforeEnter () {
      this.setPageSwitching(true)
    },
    handleAfterEnter () {
      this.setPageSwitching(false)
    }
  }
}
</script>

<style lang="scss">
.v-modal {
  background: #000;
  opacity: 0.7;
}
</style>
<style lang="scss" scoped>
#app {
  position: relative;
  width: 100%;
  height: 100vh;

  .app-wrapper {
    box-sizing: border-box;
    transition: transform 0.3s cubic-bezier(0.55, 0, 0.1, 1);

    &.slide-left-enter-active {
      transform: translate3d(100%, 0, 0);
    }

    &.slide-right-enter-active {
      transform: translate3d(-100%, 0, 0);
    }
  }
}
</style>

<style lang="scss">
@import './assets/css/reset.scss';
@import './assets/css/resetMint.scss';
</style>
